export const GLOBAL_STATE = 'DormitoryApp'

export const ACCOMMODATION = 'ACCOMMODATION' as const
export const ACCOMMODATION_CREATE = 'ACCOMMODATION_CREATE' as const
export const ACCOMMODATION_DELETE = 'ACCOMMODATION_DELETE' as const
export const ACCOMMODATION_LIST = 'ACCOMMODATION_LIST' as const
export const ACCOMMODATION_STUDENT_INFO = 'ACCOMMODATION_STUDENT_INFO' as const
export const ACCOMMODATION_CHANGE_STATUS = 'ACCOMMODATION_CHANGE_STATUS' as const
